import type { UserData } from 'models/Auth'

type AuthUserData = UserData['auth']['userData']

export function getProfessionalUuidFromAuthUserData(user: AuthUserData | undefined): string {
  if (!user) return ''
  return user.uuid ?? user.person_general?.uuid ?? user.session?.uuid ?? ''
}
